export const getStatusCellElement = (profileId: string): HTMLElement | null => {
  return document.querySelector(`[data-status-cell-id="${profileId}"]`);
};
